module.exports = __webpack_public_path__ + "img/13.9bd13b53.png";